const MODAL_QUERY_PARAM_KEY = "modal";

const VERIFY_EMAIL_MODAL_QUERY_PARAM = "verify-email";
const CREATE_USERNAME_MODAL_QUERY_PARAM = "create-username";
const AUTH_INTERRUPT_MODAL_QUERY_PARAM = "login";

export {
  MODAL_QUERY_PARAM_KEY,
  VERIFY_EMAIL_MODAL_QUERY_PARAM,
  CREATE_USERNAME_MODAL_QUERY_PARAM,
  AUTH_INTERRUPT_MODAL_QUERY_PARAM,
};
